
export const easterCamp = {
  title: "Camp de Pâques",
  subtitle: "Une expérience unique d'apprentissage et d'amusement au contact de la nature",
  gallery: {
    title: "Galerie",
    caption: "Moments de nos camps de Pâques",
    images: [
      { src: "/lovable-uploads/patio-futbol-pradera.png", alt: "Enfants explorant la nature" },
      { src: "/lovable-uploads/patio-carpinteria-cana.png", alt: "Activités en plein air" },
      { src: "/lovable-uploads/huerta-charco-barro.png", alt: "Matériel Montessori" }
    ]
  },
  description: {
    title: "Aperçu du Camp",
    content1: "Notre camp de Pâques propose une variété d'activités comprenant des ateliers de cuisine, des expériences scientifiques, des jeux en plein air et des activités artistiques avec Voadoras. Nous concevrons des activités détaillées une fois que nous connaîtrons le nombre d'enfants participants, mais nous enverrons des exemples d'activités et d'ateliers dans les prochains jours.",
    content2: "Nos enseignants ont de nombreuses idées de cuisine et d'activités créatives prévues. Nous utiliserons les matériaux disponibles à Gándara, créant un environnement qui encourage l'exploration, la créativité et l'amusement !"
  },
  activities: {
    title: "Activités et Ateliers",
    list: [
      "Ateliers de cuisine adaptés aux enfants",
      "Expériences scientifiques amusantes et éducatives",
      "Jeux dans la nature et exploration en plein air",
      "Art créatif avec Voadoras",
      "Projets d'art en argile avec des textures d'objets quotidiens, d'éléments naturels et de matériaux recyclés",
      "Projets artistiques inspirés de l'artiste Louise Nevelson, créant des sculptures avec des matériaux recyclés"
    ]
  },
  spaces: {
    title: "Espaces d'Apprentissage",
    intro: "Nous créerons différents coins d'activités dans l'espace de bureau :",
    list: [
      {
        title: "COIN LECTURE",
        description: "Un espace confortable avec un tapis, des coussins et une étagère avec des histoires."
      },
      {
        title: "ESPACE DE DÉTENTE",
        description: "Un tipi, un tapis, des peluches, un matelas et des tissus. Les espaces 1 et 2 seront ensemble."
      },
      {
        title: "JEU SYMBOLIQUE",
        description: "Cuisine, table, vaisselle et accessoires pour le jeu imaginatif."
      },
      {
        title: "CONSTRUCTION ET MINI-MONDES",
        description: "Tous les matériaux de construction (magnétiques, pièces en bois...), conteneurs avec des pièces détachées."
      },
      {
        title: "COIN ARTISTIQUE",
        description: "Une petite table de maternelle et une petite étagère avec du matériel artistique."
      }
    ]
  },
  schedule: {
    title: "Programme Quotidien",
    list: [
      "Arrivée et jeu libre",
      "Assemblée et introduction de la journée",
      "Atelier",
      "Goûter",
      "Jeu libre",
      "Atelier",
      "Assemblée finale et relaxation"
    ]
  },
  prices: {
    title: "Prix",
    headers: {
      fullCamp: "4 Jours",
      singleDay: "Jour Unique",
      earlyBird: "Accueil matinal",
      lunch: "Déjeuner"
    },
    students: "Élèves de Gándara",
    external: "Élèves Externes"
  },
  contact: {
    title: "Contactez-nous",
    button: "Réserver une Visite"
  }
};

export const christmasCamp = {
  title: "Camp de Noël",
  subtitle: "Un camp où le jeu libre, la curiosité et la créativité guident chaque jour, avec un accompagnement proche et respectueux",
  gallery: {
    title: "Galerie",
    caption: "Moments magiques de notre camp de Noël",
    images: [
      { src: "/lovable-uploads/christmas-camp-poster.jpg", alt: "Affiche du Camp de Noël" }
    ]
  },
  description: {
    title: "Aperçu du Camp",
    content1: "Célébrez les fêtes avec nous dans une atmosphère magique où les enfants pourront profiter d'activités créatives, d'ateliers de Noël et de moments de jeu libre.",
    content2: "Notre équipe d'accompagnateurs crée un espace sûr et respectueux où chaque enfant peut explorer, créer et s'amuser à son propre rythme."
  },
  activities: {
    title: "Activités",
    list: [
      "Ateliers créatifs de Noël",
      "Cuisine saine et recettes de saison",
      "Ateliers d'art et d'expression sensorielle",
      "Jeu libre et exploration",
      "Activités en plein air",
      "Contes et musique"
    ]
  },
  schedule: {
    title: "Dates et Horaires",
    dates: "22 décembre 2026 au 7 janvier 2027",
    note: "(sauf jours fériés)",
    hours: "Horaire: 9h00 - 14h00",
    extended: "Étendu: 8h30 - 15h30",
    ages: "Âges: 3 à 12 ans"
  },
  prices: {
    title: "Prix",
    members: "Membres Gándara",
    nonMembers: "Non-membres",
    oneWeek: "1 Semaine",
    complete: "Complet"
  },
  contact: {
    title: "Réservez votre place!",
    button: "S'inscrire"
  }
};

export const summerCamp = {
  title: "Camp d'Été 2026",
  subtitle: "Rejoignez-nous pour une expérience inoubliable au camp d'été de Gándara International School",
  gallery: {
    title: "Galerie",
    caption: "Moments de nos camps d'été",
    images: [
      { src: "/lovable-uploads/86807e57-9b48-4117-811e-2178c1e55e7d.png", alt: "Enfants jouant en plein air" },
      { src: "/lovable-uploads/4fb227e3-a5f5-4a84-94b3-bdbd9ebd058b.png", alt: "Exploration de la nature" },
      { src: "/lovable-uploads/b8f5b9b1-cac2-4895-b283-d2a0df3dbed9.png", alt: "Activités créatives" }
    ]
  },
  intro: "Cet été, à Gándara International School, nous ouvrons nos portes à une expérience inoubliable : un camp unique où la nature, le jeu et le développement émotionnel s'entrelacent pour offrir à chaque enfant un été plein de magie, de découverte et de croissance personnelle.",
  educationalProposal: {
    title: "Une proposition éducative différente",
    content: "À Gándara International School, nous croyons qu'un avenir brillant commence par une enfance vécue pleinement. Notre camp n'est pas seulement un espace de loisirs, mais une expérience éducative complète, dans un environnement où les enfants peuvent:",
    items: [
      "Se reconnecter avec la nature et avec leur propre rythme intérieur.",
      "Découvrir le monde à travers le jeu, l'émotion et la curiosité.",
      "Se sentir écoutés, accompagnés et respectés."
    ],
    additional: "Chaque jour est une opportunité de grandir, d'imaginer, d'explorer, d'apprendre et de partager. Ce camp est né de l'engagement pédagogique de Gándara International School, intégrant des méthodologies telles que:",
    methodologies: [
      "Éducation dans la nature (école de forêt et apprentissage de l'anglais)",
      "Propositions STEM pour éveiller la pensée logique et scientifique",
      "Activités de lecture, histoires et écriture créative pour nourrir le langage, l'expression et l'imagination"
    ],
    conclusion: "Une combinaison qui stimule à la fois l'apprentissage actif et le développement émotionnel et social.",
    workshopsTitle: "Ateliers thématiques hebdomadaires",
    workshops: [
      { day: "Lundi", activity: "Art" },
      { day: "Mardi", activity: "Travaux manuels" },
      { day: "Mercredi", activity: "Cuisine" },
      { day: "Jeudi", activity: "Expériences et propositions des enfants" },
      { day: "Vendredi", activity: "Sorties" }
    ],
    workshopsNote: "Les ateliers ne sont pas obligatoires et peuvent être modifiés en fonction des participants."
  },
  principles: {
    title: "Nos principes pédagogiques",
    list: [
      "Connexion avec la nature à partir de l'expérience directe",
      "Jeu libre comme base pour l'apprentissage",
      "Accompagnement individualisé et respectueux",
      "Dynamiques qui favorisent l'empathie, la coopération et l'autorégulation",
      "Activités significatives pour développer l'intelligence pratique et émotionnelle",
      "Espaces pour grandir avec confiance, autonomie et joie",
      "Encourager la curiosité scientifique et la pensée logique à travers des propositions STEM adaptées à chaque étape"
    ]
  },
  audience: {
    title: "À qui s'adresse-t-il?",
    ageGroups: "Enfants de 3 à 12 ans",
    ratio: "Ratio 1:14",
    note: "Nous travaillons avec des petits groupes, assurant une attention personnalisée et un accompagnement étroit."
  },
  location: {
    title: "Localisation privilégiée",
    name: "Gándara International School",
    address: "Gondomar (Pontevedra)",
    description: "Un environnement rural naturel, sûr et plein de possibilités:",
    features: [
      "Vastes jardins extérieurs avec piscine",
      "Salles polyvalentes pour ateliers et activités calmes",
      "Cuisine, salles de bains et zones couvertes adaptées aux enfants et à la météo",
      "Jardin scolaire actif tout au long de l'été"
    ]
  },
  schedule: {
    title: "Dates et horaires",
    dates: "Du 22 juin au 4 septembre 2026",
    days: "Du lundi au vendredi, en matinée",
    holidays: "Jours fériés : 24 juin (fête régionale) et 17 août (fête locale)",
    timetable: {
      title: "Horaire type:",
      slots: [
        { time: "09:00 - 10:00", activity: "Arrivée flexible" },
        { time: "10:00 - 10:30", activity: "Cercle du matin : présentation de l'atelier du jour et temps de partage" },
        { time: "10:30 - 11:30", activity: "Atelier thématique du jour" },
        { time: "11:30 - 12:00", activity: "Goûter" },
        { time: "12:00 - 13:30", activity: "Jeu libre, y compris piscine" },
        { time: "13:30 - 14:00", activity: "Rangement du matériel et au revoir" },
        { time: "14:00 - 15:30", activity: "Déjeuner (lunch box de la maison)" }
      ]
    }
  },
  included: {
    title: "Que comprend le camp?",
    items: [
      "Ateliers thématiques quotidiens (art, travaux manuels, cuisine, expériences, sorties)",
      "Jeu libre et temps de piscine",
      "Matériels didactiques et créatifs",
      "Accompagnement respectueux par des professionnels qualifiés",
      "Assurance responsabilité civile et accidents",
      "Possibilité de service de déjeuner (avec lunch box de la maison)",
      "Possibilité de concilier : accueil matinal et sortie tardive"
    ]
  },
  toBring: {
    title: "Que doivent apporter les enfants?",
    items: [
      "Vêtements confortables qui peuvent se salir",
      "Sac à dos avec bouteille d'eau et goûter",
      "Casquette et protection solaire",
      "Serviette et maillot de bain (pour la piscine)",
      "Vêtements de rechange",
      "Imperméable (en cas de pluie)"
    ],
    note: "Tout marqué avec leur nom pour éviter les pertes."
  },
  registration: {
    cta: "Inscrivez-vous maintenant",
    title: "Inscription",
    limitedSpots: "Places limitées!",
    options: "Vous pouvez vous inscrire par semaine ou pour tout l'été.",
    form: {
      title: "Formulaire d'inscription",
      parentInfo: "Information du parent/tuteur",
      childInfo: "Information de l'enfant",
      weeksSelection: "Sélection des semaines",
      options: "Options additionnelles",
      membership: "Adhésion à Gándara",
      submit: "Envoyer l'inscription"
    }
  },
  pricing: {
    title: "Prix",
    weeks: {
      oneWeek: "1 Semaine",
      twoWeeks: "2 Semaines",
      threeWeeks: "3 Semaines",
      fourWeeks: "4 Semaines",
      fiveWeeks: "5 Semaines"
    },
    members: "Membres de Gándara",
    nonMembers: "Non-membres",
    options: {
      lunch: "Déjeuner (lunch box de la maison)",
      earlyDropoff: "Accueil matinal",
      latePickup: "Sortie tardive"
    },
    labels: {
      daily: "Quotidien",
      weekly: "Hebdomadaire",
      monthly: "Mensuel",
      perSection: "Par créneau"
    },
    discounts: {
      title: "Réductions pour les frères et sœurs",
      secondChild: "10% de réduction pour le 2ᵉ enfant",
      thirdChild: "25% de réduction pour le 3ᵉ enfant et suivants"
    }
  },
  faq: {
    title: "Questions fréquemment posées",
    questions: [
      {
        question: "Quels âges peuvent participer au camp?",
        answer: "Les enfants de 3 à 12 ans peuvent participer, avec un ratio de 1:14."
      },
      {
        question: "Que se passe-t-il si mon enfant a des restrictions alimentaires?",
        answer: "Veuillez indiquer toute allergie ou restriction alimentaire sur le formulaire d'inscription, et nous nous adapterons en conséquence."
      },
      {
        question: "Quelle est la politique d'annulation?",
        answer: "Les annulations effectuées jusqu'à deux semaines avant la date de début reçoivent un remboursement complet. Les annulations dans les deux semaines précédant la date de début reçoivent un remboursement de 50%. Pas de remboursement pour les annulations dans les 72 heures précédant la date de début."
      },
      {
        question: "Les ateliers sont-ils obligatoires?",
        answer: "Non, les ateliers ne sont pas obligatoires. Les enfants peuvent participer librement et les activités peuvent être modifiées en fonction des participants."
      }
    ]
  }
};

export const summerCampConfirmation = {
  title: "Inscription Envoyée !",
  subtitle: "Nous avons reçu votre inscription au camp d'été. Vous recevrez un email de confirmation sous peu.",
  contactTitle: "Besoin de nous contacter ?",
  contact: {
    phone: "Téléphone",
    email: "Email",
  },
  backToCamp: "Retour au camp",
  backToHome: "Retour à l'accueil",
  note: "Si vous ne recevez pas l'email de confirmation, vérifiez votre dossier spam ou contactez-nous directement.",
};
